//#region imports
import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Colors, Spacing } from '_styles';
import { handleNotesText } from '_utils/functions';
import { PiNotepadFill } from 'react-icons/pi';
//#endregion

/**
 * JobNoteIcon - Displays a note icon with hover overlay if the job has notes
 * @param {Object} job - The job/booking object
 * @param {boolean} hasNote - Whether the job has a note
 */
const JobNoteIcon = ({ job, hasNote }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const handleMouseEnter = useCallback((e) => {
        setIsHovered(true);
        setMousePosition({ x: e.clientX, y: e.clientY });
    }, []);

    const handleMouseLeave = useCallback(() => {
        setIsHovered(false);
    }, []);

    const handleMouseMove = useCallback((e) => {
        setMousePosition({ x: e.clientX, y: e.clientY });
    }, []);

    if (!hasNote) {
        return (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
        );
    }

    const notesContent = handleNotesText(job, "tooltip");

    return (
        <div 
            style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative'
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
        >
            <PiNotepadFill color={Colors.GRAY_DARK} size={14} />

            {/* Hover Overlay - rendered via portal */}
            {isHovered && notesContent && createPortal(
                <div
                    style={{
                        position: 'fixed',
                        left: mousePosition.x + 10,
                        top: mousePosition.y + 10,
                        backgroundColor: 'white',
                        border: `1px solid ${Colors.GRAY_LIGHT}`,
                        borderRadius: 8,
                        padding: Spacing.SCALE_8,
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        zIndex: 2147483647,
                        maxWidth: 250,
                        whiteSpace: 'pre-line',
                        fontSize: 12,
                        color: Colors.TEXT_DARK,
                        pointerEvents: 'none',
                    }}
                >
                    <div style={{ fontWeight: 'bold', marginBottom: 4, color: Colors.PRM_BLUE }}>
                        Notes
                    </div>
                    {notesContent}
                </div>,
                document.body
            )}
        </div>
    );
};

export default JobNoteIcon;
